import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { GanttDate, GanttGroup, GanttGroupInternal, GanttItem, GanttItemInternal, GanttViewOptions, GanttViewType, NgxGanttComponent } from '@worktile/gantt';
import { ColumnType, DatePickerType, DialogConfig, FilterOperator, FilterOptions, FilterOptionsType, ISAPI, ISColumn, ISDialogService, ISFilterAPI, ISMultiSelectDatasource, ISMultiSelectOption, ISPagination, ISSelectOption, TemplateLayouts } from 'is-lib';
import { User } from 'oidc-client';
import { BehaviorSubject, forkJoin, fromEvent, merge, mergeWith, Observable, skipWhile, takeWhile } from 'rxjs';
import { Alert, AlertWithTimediff } from 'src/app/models/Alert';
import { IClientPortalUser } from 'src/app/models/Client';
import { IContract } from 'src/app/models/Contract';
import { Grouping, IGrouping } from 'src/app/models/Grouping';
import { IPrice, Price } from 'src/app/models/Price';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { AlertsService } from 'src/app/services/alerts.service';
import { AuthService } from 'src/app/services/auth.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { GroupingsService } from 'src/app/services/groupings.service';
import { LanguageService } from 'src/app/services/language.service';
import { UsersService } from 'src/app/services/users.service';
import { environment } from 'src/environments/environment';
import { OpportunityFormComponent } from '../../opportunities/opportunity-form/opportunity-form.component';
import { OpportunitiesService } from 'src/app/services/opportunities.service';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-market-dealers-dashboard',
    templateUrl: './market-dealers-dashboard.component.html',
    styleUrls: ['./market-dealers-dashboard.component.scss']
})
export class MarketDealersDashboardComponent implements OnInit {

    @ViewChild(NgxGanttComponent) gantTimetableComponent!: NgxGanttComponent

    user?: IClientPortalUser;
    userClaims: any[] = []

    _isLoadingFlag = false;

    priceItems: GanttItem<Price>[] = [];
    
    //#region GanttChart
    viewTypes = GanttViewType;

    viewOptions: GanttViewOptions = {
        dateFormat: {
            week: 'W',
            month: 'MM',
            quarter: 'QQQ',
            year: 'yyyy',
            yearMonth: 'yyyy/MM',
            yearQuarter: 'yyyy/QQQ'
        },
        start: new GanttDate(new Date()),
        end: new GanttDate(new Date()).addYears(2)
    };
    
    groups: GanttGroup[] = [];

    items: GanttItem[] = [];
    //#endregion
    
    requestsCompleteFlag: boolean = false;

    groupings: Grouping[] = []
    contracts: IContract[] = []

    constructor(
        private _usersService: UsersService,
        protected _alertsService: AlertsService,
        private _groupingsService: GroupingsService,
        private _contractService: ContractsService,
        private _cdRef: ChangeDetectorRef,
        private _dialogService: ISDialogService,
        private _opportunitiesService: OpportunitiesService,
        private _translateService: TranslateService,
        private _router: Router
    ) { 
        this.user = _usersService.userData!;
    }

    ngOnInit(): void {
        this._groupingsService.getGroupings().subscribe({ 
            next: (sr: ServerResponse<Grouping[]>) => {
                if (sr.data && sr.data.length > 0) {
                    let cnt = 0;

                    // sr.data.forEach( (gr: Grouping) => {
                    //     let grIndex = this.groupings.push(new Grouping(gr));
                    //     this._groupingsService.getGroupingPrices(gr.id!).subscribe((sr_1: ServerResponse<Price[]>) => {
                    //         if (sr_1 != null) {
                    //             this.groupings[grIndex - 1].prices = sr_1.data.map((pr) => new Price(pr));
                                
                    //             if (cnt == sr.data.length - 1) {
                    //                 this.convertGroupingPricesToChartItems();
                    //                 this.requestsCompleteFlag = true;
                    //             }

                    //             cnt++;
                    //         }
                    //     });
                    // });

                    this.groups = this.groupings.map( (gr) => {
                        return {
                            id: gr.id!,
                            title: gr.internalCode!
                        }
                    });
                }
            } 
        });
    }

    

    protected openOpportunityCreationDialog(groupingId?: string, priceId?: string, opportunityId?: string) {
        this._dialogService.open(
            OpportunityFormComponent,
            {
                title: this._translateService.instant('NEW_EQUIPMENT_GROUP'),
                data: {
                    groupingId: groupingId,
                    priceId: priceId,
                    opportunityId: opportunityId
                },
                template: TemplateLayouts.entities,
                width: 1345,
                height: 744
            }
        )
    }

    navigateTo(url: string) {
        this._router.navigate(['/market-dealers', url]);
    }

    private refreshTimelineView(prices?: GanttItem<Price>[]) {


        this.viewOptions = {...this.viewOptions};
        this.priceItems = [...prices ?? this.priceItems];

        this._cdRef.detectChanges();
    }

    private convertGroupingPricesToChartItems() {

        let priceFilter = (price: Price) => { return price.deliveryStartDate != null && price.deliveryEndDate != null; }
        let priceItems: GanttItem<Price>[] = [];

        this.groupings.forEach((grouping: Grouping) => {
            priceItems.push(...grouping.prices.filter(priceFilter).map( (pr: Price, index: number) => {
                let startDate = pr.deliveryStartDate!.getTime();
                let endDate = pr.deliveryEndDate!.getTime();

                let priceItem: GanttItem<Price> = { id: pr.id!, title: pr.description!, group_id: grouping.id, start: Math.round(startDate / 1000), end: Math.round(endDate / 1000) };

                return priceItem;
            }));
        })

        this.refreshTimelineView(priceItems);
    }

    protected getTimelineItemClass(item: GanttItem): 'future' | 'active' | 'expired' {
        let currentDateInSeconds = new Date().getTime() / 1000;
        
        if ( item.end! < currentDateInSeconds ) {
            return 'expired';
        }

        if ( item.start! > currentDateInSeconds ) {
            return 'future';
        }

        return 'active';
    }

    protected isNullOrUndefinedOrWhitespace(s: string) {
        return String.isNullOrUndefinedOrWhitespace(s);
    }
}


